export default {"src":"/_next/static/media/goldcard.6cd8e357.svg","height":221,"width":182,"blurWidth":0,"blurHeight":0};